// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import Notifications from '@material-ui/icons/Notifications';
import Badge from './Badge';
import loadNotifications from '../state/loadNotifications';
import getNotificationCounts from '../api/getNotificationCounts';
import markNotificationsAsViewed from '../state/markNotificationsAsViewed';
import { getStore } from '../../../state/store';
import * as AppState from '../../../state/reducer/app/appState';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';
import Console from '../../../lib/debug';

const BACKOFF_INTERVALS_MS = [60000, 90000, 180000, 300000];

class NotificationButton extends PureComponent {
    constructor(props: any) {
        super(props);
        this.pollTimeout = null;
        this.backoffIndex = 0;
        this.prevCount = null;
        this.state = { badgeCount: 0 };
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.fetchNotificationCount();
    }

    componentWillUnmount() {
        clearTimeout(this.pollTimeout);
        this.pollTimeout = null;
    }

    async fetchNotificationCount() {
        const response = await getNotificationCounts();
        const countNotViewed = response
            ? response.countNotificationNotViewed
            : 0;

        if (countNotViewed === this.prevCount) {
            this.backoffIndex = Math.min(
                this.backoffIndex + 1,
                BACKOFF_INTERVALS_MS.length - 1
            );
        } else {
            this.backoffIndex = 0;
        }
        this.prevCount = countNotViewed;

        if (countNotViewed > this.state.badgeCount) {
            getStore().dispatch(loadNotifications());
        }

        this.setState({ badgeCount: countNotViewed });

        this.pollTimeout = setTimeout(
            () => this.fetchNotificationCount(),
            BACKOFF_INTERVALS_MS[this.backoffIndex]
        );
    }

    onClick() {
        SegmentService.track(SEGMENT_EVENTS.ClickCTA.key, {
            sources: 'Web app',
            ctaLocation: 'Main Nav',
            ctaText: 'Bell Icon'
        });
        getStore().dispatch(loadNotifications());
        this.setState({ badgeCount: 0 }, () => {
            getStore().dispatch(markNotificationsAsViewed());
            AppState.navigate('/notifications');
        });
    }

    render() {
        Console.render('NotificationButton');
        return (
            <IconButton
                className="notification-link"
                aria-label="Notification Bell"
                onClick={this.onClick}
            >
                <Notifications className="notification-bell" />
                {this.state.badgeCount > 0 ? (
                    <Badge count={this.state.badgeCount} />
                ) : null}
            </IconButton>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        features: state.features
    };
};

NotificationButton = connect(mapStateToProps)(NotificationButton);

export default NotificationButton;
